import { memo, useMemo } from 'react';
import { listIconContact } from '../../../../constant/user-setting-modal-resources';
import {
  IDetailProfileInfoFC as IContactProps,
  UserSettingEnum,
} from '../../../../interfaces/profile.interface';
import ProfileInfoEditButton from '../button/ProfileInfoEditButton';

const ContactComponent: React.FC<IContactProps> = ({
  data,
  roleView,
  setModal,
}) => {
  const item = useMemo(() => data, [data]);

  const isPhoneNumber = item.contactType === 0 || item.contactType === 2;
  const hashContentToContactType = {
    0: 'Số điện thoại cá nhân',
    1: 'Email cá nhân',
    2: 'Số điện thoại công việc',
    3: 'Email công việc',
  };

  return (
    <div className="flex justify-between py-2 bg-[#2691BD]/[4%] rounded-[10px] px-3">
      <a
        href={`${isPhoneNumber ? `tel` : `mailto`}:${item.contactInfo}`}
        target="_blank"
        rel="noreferrer"
        className="cursor-pointer flex flex-1 items-center"
      >
        <span>
          <p className="text-primary text-lg flex justify-center items-center w-[24px]">
            {listIconContact[item.contactType as number].icon}
          </p>
        </span>
        <div className="w-full overflow-hidden mx-4">
          <p className="text-primary_black text-[14px] w-fit line-clamp-1 overflow-hidden">
            {item.contactInfo}
          </p>
          <p className="text-[#979797] text-[12px]">
            {
              hashContentToContactType[
                item.contactType as keyof typeof hashContentToContactType
              ]
            }
          </p>
        </div>
      </a>
      <ProfileInfoEditButton
        value={item}
        roleView={roleView}
        modalName={UserSettingEnum.Contact}
        setModal={setModal}
      />
    </div>
  );
};

export default memo(ContactComponent);
